import { translate } from '@/shared/utils/branded-translation'

export class TranslateService {
  public translate(key: string): string {
    return translate(key) as string
  }
}
